"use client";

import { useCallback, useContext } from "react";
import { languageContext } from "@/contexts/language-context";
import { rv2T } from "./i18n";
import type { Rv2Key, Rv2Lang } from "./i18n";
import type { Rv2Vars } from "./i18n";

export function useRv2Lang(): Rv2Lang {
  const ctx = useContext(languageContext);
  return (["fr", "en", "ar"].includes(ctx?.lang ?? "") ? ctx!.lang : "fr") as Rv2Lang;
}

export function useRv2T() {
  const lang = useRv2Lang();
  return useCallback(
    (key: Rv2Key | string, vars?: Rv2Vars) => rv2T(lang, key, vars),
    [lang],
  );
}
